import { API_BASE_URL } from "./marketDataApi";

const SAFE_EVENT_TYPES = new Set(["trade", "bar", "updatedBar"]);

function normalizedSymbol(symbol) {
  return String(symbol || "").trim().toUpperCase();
}

export function stockMarketDataStreamUrl(symbol, apiBaseUrl = API_BASE_URL) {
  const normalized = normalizedSymbol(symbol);
  if (!normalized) throw new Error("A stock symbol is required.");

  const url = new URL(apiBaseUrl);
  if (url.protocol === "http:") url.protocol = "ws:";
  else if (url.protocol === "https:") url.protocol = "wss:";
  else throw new Error("The market-data API URL must use HTTP or HTTPS.");

  url.pathname = `/market-data/stream/stocks/${encodeURIComponent(normalized)}`;
  url.search = "";
  url.hash = "";
  return url.toString();
}

export function connectStockMarketDataStream(
  symbol,
  { onStatus, onEvent, onDisconnect } = {},
  { WebSocketImpl = window.WebSocket, apiBaseUrl = API_BASE_URL } = {}
) {
  const expectedSymbol = normalizedSymbol(symbol);
  const url = stockMarketDataStreamUrl(expectedSymbol, apiBaseUrl);
  const socket = new WebSocketImpl(url);
  let closedByClient = false;
  let disconnectReported = false;

  const reportDisconnect = (reason) => {
    if (closedByClient || disconnectReported) return;
    disconnectReported = true;
    if (typeof onDisconnect === "function") onDisconnect(reason);
  };

  socket.onmessage = (message) => {
    let payload;
    try {
      payload = JSON.parse(message.data);
    } catch (_error) {
      return;
    }

    if (payload?.type === "status") {
      if (typeof onStatus === "function") onStatus(payload);
      return;
    }

    if (
      !SAFE_EVENT_TYPES.has(payload?.type) ||
      normalizedSymbol(payload?.symbol) !== expectedSymbol ||
      payload?.feed !== "iex"
    ) {
      return;
    }
    if (typeof onEvent === "function") onEvent(payload);
  };

  socket.onerror = () => reportDisconnect("error");
  socket.onclose = () => reportDisconnect("closed");

  return {
    url,
    socket,
    close() {
      closedByClient = true;
      if (
        socket.readyState === WebSocketImpl.CONNECTING ||
        socket.readyState === WebSocketImpl.OPEN
      ) {
        socket.close(1000, "Client closed");
      }
    },
  };
}
